import React, { useEffect, useState } from 'react'
import { Row, Col, Badge, Card, CardBody } from 'reactstrap'
import logo from "../../assets/images/dofy-logo-blue.png"
import { HelperConstant } from '../../helpers/HelperConstant'
import CommonService from 'services/CommonService'
import { IOrderSpecificationsModel } from 'models/OrderSpecifications.Model'
import moment from 'moment'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTypedDispatch } from 'features/reduxhooks/ReduxHooks'
import { pageChange } from 'features/reducers/DocumentScan/PageChange.Reducer'
import { getStatusIds } from '../../helpers/Helper'
import { isAdmin, isSuperAdmin } from '../../helpers/TokenHelper'

type inputProps = {
  // orderId: any,
  encryptedId: any,
  ProductTypeName: any,
  isFromInvoice?: boolean
  AppointmentDate?: any
  statusId?: any
}

function OrderDocumentInfo({ encryptedId, ProductTypeName, isFromInvoice, AppointmentDate, statusId }: inputProps) {
  let dispatch = useTypedDispatch();
  const [ImeiNumber, setImeiNumber] = useState<Array<IOrderSpecificationsModel>>([]);
  const [orders, setOrders] = useState<Array<any>>([]);
  const [imageSelfie, setImageSelfie] = useState<any>();
  const [imageIdproofFront, setIdproofFront] = useState<any>();
  const [imageIdproofBack, setIdproofBack] = useState<any>();
  const [imageBill, setImageBill] = useState<any>();
  const [imagewarranty, setImagewarranty] = useState<any>();
  const [ImageTop, setImageTop] = useState<any>();
  const [ImageBottom, setImageBottom] = useState<any>();
  const [ImageLeft, setImageLeft] = useState<any>();
  const [ImageRight, setImageRight] = useState<any>();
  const [ImageBack, setImageBack] = useState<any>();
  const [ImageFront, setImageFront] = useState<any>();
  const [ImageSignature, setImageSignature] = useState<any>();
  const [DataToDisplay, setDataToDisplay] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const dashboardStatusId = searchParams.get('dashboardStatusId') as any;
  let navigate = useNavigate();
  const pendingIds = `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;


  const unsecuredCopyToClipboard = (text: any) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false) }, 1000);
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }

  const copyHandler = (index: number) => {
    let content = ImeiNumber[index]?.IMEINumber;
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(content);
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false) }, 1000);
    } else {
      unsecuredCopyToClipboard(content);
    }
  };

  const [DocumentType] = useState({
    selfie: HelperConstant.documentTypeId.Selfie,
    IdproofFront: HelperConstant.documentTypeId.Id_Front,
    IdproofBack: HelperConstant.documentTypeId.Id_Back,
    Bill: HelperConstant.documentTypeId.Bill,
    warranty: HelperConstant.documentTypeId.Warranty,
    Top: HelperConstant.documentTypeId.Top,
    Bottom: HelperConstant.documentTypeId.Bottom,
    Left: HelperConstant.documentTypeId.Left,
    Right: HelperConstant.documentTypeId.Right,
    Back: HelperConstant.documentTypeId.Back,
    Front: HelperConstant.documentTypeId.Front,
    Signature: HelperConstant.documentTypeId.Signature
  });

  useEffect(() => {
    CommonService.getWithSingleEntity("orderSpecifications", "GetSpecificationsByOrderId", encryptedId).then(res => {
      if (res.status === 200) {
        setImeiNumber(res.data);
      }
    }).catch(e => {
      if (e == 'Request failed with status code 401') {
        navigate('/logout')
      } else {
        console.error("API error:", e);
      }
    })

    const GetDisplayDocuments = () => {
      CommonService.postWithQueryParam('OrderDocuments', 'GetOrderDocuments', 'orderId', encryptedId, 'application/json').then((response) => {
        setOrders(response.data);
        setDataToDisplay("ok")
        for (const res of orders) {
          const documentTypeIdData = res.DocumentTypeId;
          CommonService.postWithDoubleParam('OrderDocuments', 'GetBase64OrderDocument', 'orderId', encryptedId, 'documentTypeId', documentTypeIdData).then((res) => {
            var base64ImageString: any = `data:image/png;base64,${res.data}`;
            if (DocumentType.selfie === documentTypeIdData) {
              setImageSelfie(base64ImageString);
            }
            if (DocumentType.IdproofFront === documentTypeIdData) {
              setIdproofFront(base64ImageString);
            }
            if (DocumentType.IdproofBack === documentTypeIdData) {
              setIdproofBack(base64ImageString);
            }
            if (DocumentType.Bill === documentTypeIdData) {
              setImageBill(base64ImageString);
            }
            if (DocumentType.warranty === documentTypeIdData) {
              setImagewarranty(base64ImageString);
            }
            if (DocumentType.Top === documentTypeIdData) {
              setImageTop(base64ImageString);
            }
            if (DocumentType.Bottom === documentTypeIdData) {
              setImageBottom(base64ImageString);
            }
            if (DocumentType.Left === documentTypeIdData) {
              setImageLeft(base64ImageString);
            }
            if (DocumentType.Right === documentTypeIdData) {
              setImageRight(base64ImageString);
            }
            if (DocumentType.Front === documentTypeIdData) {
              setImageFront(base64ImageString);
            }
            if (DocumentType.Back === documentTypeIdData) {
              setImageBack(base64ImageString);
            }
            if (DocumentType.Signature === documentTypeIdData) {
              setImageSignature(base64ImageString);
            }
          }
          ).catch(e => {
            if (e == 'Request failed with status code 401') {
              navigate('/logout')
            } else {
              console.error("API error:", e);
            }
          })
        }
      });
    };
    if (getStatusIds(parseInt(dashboardStatusId)) != pendingIds) {
      GetDisplayDocuments();
    }
  }, [DocumentType, DataToDisplay]);
  // console.log('Show edit', showEdit)
  return (
    <React.Fragment>
      <Row>
        {/* <Col lg={12} className='text-center'>
          <div className="my-3">
            <img src={logo} alt="logo" height="25" />
          </div>
        </Col> */}
        {ImeiNumber.length == 0 ? <Col className='text-center' xl={12}>
          <p className='font-size-16 fw-semibold text-dofy m-0 my-4'>Yet to scan documents. Continue to complete the order.</p>
        </Col> :
          <Col className='mt-3'>
            {ImeiNumber.map((item, idx) => (
              <div key={idx}>
                {ProductTypeName === "Phone" ? <span className='font-size-13 fw-semibold text-dark'>IMEI Number</span> : <span className='font-size-12 fw-semibold text-dark'>Serial Number</span>}<br />
                <span className='text-dofy font-size-16 fw-bold'> {item.IMEINumber}</span>
                {isFromInvoice ? "" : <i className='bx bxs-copy-alt font-size-18 cursor-pointer mx-2' onClick={() => copyHandler(idx)}></i>}
                {statusId === HelperConstant.StatusId.COMPLETED && (isAdmin() || isSuperAdmin()) && (
                  <i
                    className="far fa-edit font-size-16 cursor-pointer text-primary"
                    style={{ verticalAlign: 'middle' }}
                    onClick={() => {
                      dispatch(pageChange("IMEIPage"));
                      navigate(`/final-documents-verify/${encryptedId?.replaceAll("/", "_")?.replaceAll("+", "-")}?selectedPage=IMEIPage&isEdit=true`);
                    }}
                  ></i>
                )}
                {isOpen ? <Badge color='success' className='px-2 font-size-12'>Copied</Badge> : null}
              </div>))}
            <Row>
              <p className='text-dark font-size-13 my-2 fw-semibold'>Customer Details</p>
              <Col xl={4}>
                {imageIdproofFront ?
                  <Card className='bg-light p-2 docs-card'>
                    <img className="ui-image" src={imageIdproofFront} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Id Proof Front</span >
                    </div>
                  </Card>
                  :
                  null}
              </Col>
              <Col xl={4}>
                {imageIdproofBack ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${imageIdproofBack}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Id Proof Back</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
              <Col xl={4}>
                {imageBill ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${imageBill}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Bill (Optional)</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
            </Row>
            <Row>
              <p className='text-dark font-size-13 fw-semibold'>Device Details</p>
              <Col xl={4}>
                {ImageTop ?
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageTop}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Top</span >
                    </div>
                  </Card>
                  :
                  null}
              </Col>
              <Col xl={4}>
                {ImageBottom ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageBottom}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Bottom</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
              <Col xl={4}>
                {ImageLeft ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageLeft}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Left</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
              <Col xl={4}>
                {ImageRight ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageRight}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Right</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
              <Col xl={4}>
                {ImageFront ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageFront}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Front</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
              <Col xl={4}>
                {ImageBack ? (
                  <Card className='bg-light p-2'>
                    <img className="ui-image" src={`${ImageBack}`} alt="" />
                    <div className='mt-2  d-flex justify-content-between align-items-center'>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Back</span >
                    </div>
                  </Card>

                ) :
                  null}
              </Col>
            </Row>
            {isFromInvoice &&
              <div>
                <h2 className='text-dofy'>Declaration</h2>
                <p>
                  I hereby declare that the above information provided is correct and nothing has been concealed. If any information is found wrong at any stage, I shall be held liable for the same
                </p>
              </div>
            }
            <Row>
              <p style={{ textAlign: isFromInvoice ? "right" : "unset" }} className='text-dark font-size-13 fw-semibold'>Signature Details</p>

              {isFromInvoice && <Col xl={8}></Col>}
              <Col xl={4}>
                {ImageSignature ? (
                  <Card className='bg-white p-2'>
                    <img src={`${ImageSignature}`} alt="" className={`${isFromInvoice ? 'mx-auto w-75' : "w-75"}`} onContextMenu={(e) => e.preventDefault()} />
                    <div className={`${isFromInvoice ? 'text-end' : 'mt-2 d-flex justify-content-between align-items-center'}`}>
                      <span className='m-0 mt-2 font-size-12 text-dofy me-3 fw-semibold'>Signature</span >
                    </div>
                    {isFromInvoice &&
                      <div className="text-end">
                        <p>Date: {moment(AppointmentDate).format("DD-MM-YYYY")}</p>
                      </div>
                    }
                  </Card>
                ) :
                  null}
              </Col>
            </Row>
          </Col>}
      </Row>
    </React.Fragment>
  )
}

export default OrderDocumentInfo
